/*eslint-disable max-len, quotes*/
(function () {
	var exports = {
		'yes': 'Yes',
		'no': 'No',
		'ok': 'OK',
		'cancel': 'Cancel',
		'save': 'Save',
		'submit': 'Submit',
		'delete': 'Delete',
		'replace': 'Replace',
		'skip': 'Skip',
		'close': 'Close',
		'pay-now': 'Pay now',
		'continue': 'Continue',
		'rename': 'Rename',
		'upgrade': 'Upgrade',
		'great': 'Great!',
		'more-info': 'More info',
		'required-field': 'This field is required',
		'leave-page-confirmation': 'You have unsaved changes, are you sure you want to leave this page?',
		'leave-page': 'Leave page',
		'stay-on-page': 'Stay on page',
		'continue-to-checkout': 'Continue to check out',
		'go-back': 'Go back',
		'reduce-users': 'Reduce users',
		'save-and-continue': 'Save and continue',
		'and': 'and',

		'config-user-roles-admin': 'Admin',
		'config-user-roles-member': 'Member',
		'config-user-roles-guest': 'Guest',

		'top-bar-upgrade-button-day': 'day',
		'top-bar-upgrade-button-days': 'days',
		'top-bar-upgrade-button-week': 'week', // For testing Crowdin integration only.

		'main-nav-avatar-alt': 'User profile',
		'main-nav-change-sign-in-details': 'Change sign-in details',
		'main-nav-team-profile': 'Team profile',
		'main-nav-users': 'Users & Permissions',
		'main-nav-mls-connection': 'MLS connection',
		'main-nav-fonts': 'Custom fonts',
		'main-nav-folders': 'Team folders',
		'main-nav-smartfields': 'SmartFields',
		'main-nav-customize': 'Customize',
		'main-nav-subscription': 'Billing & Plans',
		'main-nav-downloads': 'Downloads',
		'main-nav-new': 'new',

		'company-profile-header': 'Team profile',
		'company-profile-description': 'Fill out your team information.',
		'company-profile-description-read-only': 'Team information is read-only, only team administrators can modify this.',
		'company-profile-team-name': 'Team Name',
		'company-profile-team-name-placeholder': 'Team Name',
		'company-profile-team-name-taken': 'This name is already taken, please choose another team name.',
		'company-profile-team-name-length': 'Please enter more than 3 characters.',
		'company-profile-team-name-consecutive-spaces': 'You may not have multiple consecutive spaces.',
		'company-profile-team-name-leading-trailing-spaces': 'You may not have a name that starts or ends with space.',
		'company-profile-email': 'Contact email',
		'company-profile-email-placeholder': 'Email address',
		'company-profile-email-description': 'This is the main email and billing address for {0}.',
		'company-profile-email-invalid': 'Invalid email address',
		'company-profile-address': 'Address',
		'company-profile-address1-placeholder': 'Address line 1',
		'company-profile-address2-placeholder': 'Address line 2',
		'company-profile-city-placeholder': 'City',
		'company-profile-region-placeholder': 'State/Region',
		'company-profile-postcode-placeholder': 'Postcode',
		'company-profile-country-placeholder': 'Country',
		'company-profile-country-invalid': 'The country provided is not valid. Please start typing and select an entry from the list.',
		'company-profile-phone': 'Phone number',
		'company-profile-phone-placeholder': 'Phone number',
		'company-profile-phone-invalid': 'The phone number provided is not valid. Please enter a different number, using numbers and the - + ( ) characters.',
		'company-profile-website': 'Website',
		'company-profile-website-placeholder': 'https://www.yourdomain.com',
		'company-profile-website-invalid': 'The website provided is not valid. Please enter a valid website format with http:// or https://.',
		'company-profile-industry': 'Industry',
		'company-profile-industry-selector': 'Please select',
		'company-profile-industry-invalid': 'The team industry provided is not valid. Please start typing and select an entry from the list.',
		'company-profile-size': 'Team size',
		'company-profile-size-selector': 'Select...',
		'company-profile-language': 'Language',
		'company-profile-language-selector': 'Select...',
		'company-profile-updated': 'Team profile was updated',
		'company-profile-settings-error': 'Error saving team settings',

		'users-header': 'Users & Permissions',
		'users-description': 'Manage users and permissions.',
		'users-email-placeholder': 'Enter an email address',
		'users-email-error-invalid': 'Invalid email address.',
		'users-email-error-exists': 'This user already exists.',
		'users-email-already-exists-in-invite-list': 'Duplicate entry.',
		'users-message-empty': 'Message should not be empty.',
		'users-roles-popover-title': 'Roles',
		'users-roles-popover-admin': 'Admin',

		'users-roles-popover-admin-description': 'Full admin rights. Manage team and team files.',
		'users-roles-popover-member': 'Member',
		'users-roles-popover-member-description': 'Full document editing rights. Access to team files.',
		'users-roles-popover-guest': 'Guest',
		'users-roles-popover-guest-description': 'No access to team files, templates or assets. Can comment and collaborate on selected documents with limited editing capabilities. Guests don\'t use user licenses.',

		'users-add': 'Add users',
		'users-send-invitations': 'Send invitations',
		'users-confirm-role-upgrade': 'Are you sure you want to add {0} as a Team Member?',
		'users-inactive-company-information-1': 'Your plan has expired. Please',
		'users-inactive-company-information-2': 'select a subscription',
		'users-inactive-company-information-3': 'or',
		'users-inactive-company-information-4': 'update the payment details',
		'users-inactive-company-information-5': 'to reactivate it. Contact us with any questions.',

		'smartfield-photo-picker-upload-photo': 'Upload photo',
		'smartfield-photo-picker-crop-photo': 'Crop photo',
		'smartfield-photo-picker-crop-photo-drag-prompt': 'Drag to reposition your photo',
		'smartfield-photo-picker-remove-photo': 'Remove photo',

		'users-table-header-name': 'Name',
		'users-table-header-photo': 'Photo',
		'users-table-header-email': 'Email',
		'users-table-header-user-role': 'Role',
		'users-table-header-mls': 'MLS ID',
		'users-table-header-connection-status': 'Connection status',
		'users-table-header-mls-tooltip': 'Enter MLS ID to get automatic Playbooks',
		'users-table-header-mls-tooltip-agents-modal': 'Required for automatic Playbook generation.<br>When a valid ID is entered, the MLS<br> connection is set.',
		'users-table-header-select-action': 'Select action',
		'users-table-name-you': '{0} (You)',
		'users-table-enter-agent-mls-id': 'Enter Agent MLS ID',
		'users-table-click-to-enter-agent-mls-id': 'Click to enter',
		'users-table-mls-no-connections': 'No MLS connections',
		'users-table-mls-id-invalid-value': 'Invalid format.',
		'users-table-mls-id-already-used': 'This MLS ID has already been used.',
		'users-table-mls-id-done': 'Done',
		'users-table-mls-id-add': 'Add MLS ID',
		'users-remove-member-confirmation': 'Are you sure you want to remove {0} from your Member list?',
		'users-increase-confirm': 'Increase my plan from {0} to {1} users.<br/><br/>The prorated amount is {2}{3}.',
		'users-complete-team-profile': 'Before adding members to your team, please give your team a name using the <strong>Team Profile</strong> option',
		'users-team-profile': 'Team Profile',
		'users-user-added': 'An e-mail has been sent to notify {0}',
		'users-users-invited': 'An email is sent to all {0} users that haven\'t signed in to Xara.',
		'users-no-users-invited': 'All users are already in the team. No email sent.',
		'users-user-role-updated': 'Role was changed',
		'users-user-photo-updated': 'Photo has been updated',
		'users-user-photo-removed': 'Photo has been removed',
		'users-user-photo-update-error': 'Error happened during photo upload/update, please try again or contact suppport.',
		'users-user-photo-remove-error': 'Error happened during photo removal, please try again or contact suppport.',
		'users-user-removed': '{0} was removed',
		'users-table-header-admins-and-members': 'Admins & Members',
		'users-table-header-guests': 'Guests',
		'users-table-no-guests-found': 'No guests found',
		'users-table-change-sorting-order': 'Change sorting order',
		'users-table-mls-connected': 'Connected',
		'users-table-mls-not-connected': 'Not connected',
		'users-popup-header': 'Invite users',
		'user-type-all': 'All',
		'user-type-admins': 'Admins',
		'user-type-members': 'Members',
		'user-type-pending': 'Pending',
		'user-type-no-invitation': 'No invitation sent',
		'user-type-invitation-sent': 'Invitation sent',
		'user-type-type': 'Type: ',
		'user-menu-send-invite': 'Send invitation',
		'user-menu-resend-invite': 'Resend invitation',
		'user-table-username-pending-prompt': '(Pending sign up)',
		'user-table-photo-pending-prompt': 'Upload after sign up',
		'user-table-mls-pending-prompt': 'Enter after sign up',
		'users-popup-invite-all': 'Invite all',
		'users-popup-invitation-email-message-label': 'Invitation email message:',
		'users-popup-invitation-email-message-value': '(Default invitation message)',
		'users-popup-new-user-email-address': 'Enter an email address',
		'users-popup-add-another': 'Add another',
		'users-popup-saving-users': 'Saving users',
		'users-batch-add-error-offline': 'Cannot reach server. Please check your network connection and try again in a few seconds.',
		'users-batch-add-error-unknown': 'An unknown error occurred.',

		'users-batch-add-error-cant-modify-users': 'Can\'t modify users. Please try again. If the problem continues, contact us.',
		'users-batch-add-error-failed-to-add-user-to-company': 'Failed to add user to company. Please try again. If the problem continues, contact us.',
		'users-batch-add-error-invalid-user': 'Invalid user. Please try again. If the problem continues, contact us.',
		'users-batch-add-error-invalid-users': 'Invalid users. Please try again. If the problem continues, contact us.',
		'users-batch-add-error-user-already-exists': 'One of more users already exist. Please try again. If the problem continues, contact us.',
		'users-batch-add-error-plan-prohibits-user-modification': 'Subscription plan prohibits user modification',

		'users-external-id-error-invalid-company-id': 'Invalid company ID',
		'users-external-id-error-external-ids-must-be-an-array': 'External IDs must be an array',
		'users-external-id-error-target-user-not-in-the-company': 'Target user not in the company',
		'users-external-id-error-failed-to-update-external-id': 'Failed to update external IDs',
		'users-external-id-error-unknown': 'Failed to update external IDs. Unknown error.',
		'users-external-id-duplicates': 'This MLS ID has already been used.',

		'users-please-errors-found-in-the-form': 'There\'s an issue with one or more invites.',

		'product-quantity-error': 'Invalid number',
		'product-quantity-licenses-label': 'Number of licenses to buy',
		'product-quantity-users-label': 'Number of user licenses',
		'product-quantity-numbers-of-users-reminder': 'Reminder: You currently have {0} users on the team.',
		
		'license-info-perpetual': 'Install on up to 2 devices with each license.',
		'license-info-desktop-plus': 'Each user can install the product on up to 2 devices.',
		'license-info-desktop-plus-extended': 'For Photo & Graphic Designer+, Web Designer+, and Designer Pro+, each user can Install on up to 2 devices.',
		'license-info-scale': 'Each user can install the product on up to 2 devices.',

		'fonts-header': 'Custom fonts',
		'fonts-description': 'Upload your team fonts to make them available for the whole team.<br />Xara Cloud can add the following file types: .ttf .otf.',
		'fonts-upload-button': 'Upload team font',
		'fonts-table-header': 'Uploaded team fonts',
		'fonts-delete-confirmation': 'Do you want to delete this font?',
		'fonts-font-exists-confirmation': '{0} is already in the font list. Do you want to replace the file?',
		'fonts-size-exceeded': 'The font file you tried to upload is larger than the 20MB maximum size.',
		'fonts-added': '{0} was added',
		'fonts-replaced': '{0} has been replaced',
		'fonts-removed': '{0} was removed',

		'cloud-folders-documents': 'Documents',
		'cloud-folders-assets': 'Assets',

		'base-asset-display-name': 'Display name:',

		'documents-description': '<span>Select a folder from your cloud storage to create a central storage location for your team.</span><br/><br/><span>All team members and team admins will have full read and write access to this folder and all sub folders through Xara Cloud.</span>',
		'documents-your-document-folder': 'Your document folder',
		'documents-remove-folder-message': 'Do you want to remove this folder - {0}',
		'documents-remove-folder-cta': 'Remove folder',
		'documents-browse-drives': 'Browse drives',
		'documents-error-limited': 'You are limited to one document folder.<br/>Please remove the current folder to add a new one.',

		'assets-description-not-selected': 'Asset folders are automatic one-click links in Xara Cloud for users to add team assets like logos, images, diagrams, graphics and more, to any document.',
		'assets-description-logo': 'Select a folder that contains logos you want to share with your team.<br/>Supported file types: png, jpg, jpeg, bmp, tiff, xar, web, svg.',
		'assets-description-image': 'Select a folder that contains images you want to share with your team.<br/>Supported file types: jpg, jpeg, tiff, png, svg, tif, bmp.',
		'assets-description-component': 'Set additional folders with assets your team uses frequently.<br/>Supported file types: svg, ai, pptx, xar, web.',
		'assets-step-1': 'Step 1',
		'assets-step-1-description': 'Select assets category type.',
		'assets-step-2': 'Step 2',
		'assets-step-2-description': 'Select the cloud storage where the assets are located.',

		'asset-browse-drives': 'Browse drives',
		'asset-folders': 'Your {0} folders',
		'asset-folder-remove-message': 'Do you want to remove this folder - {0}?',
		'asset-folder-remove-button-remove': 'Remove folder',
		'asset-folder-add-button': '+ Add',
		
		'cloud-browser-shared': 'Shared',
		'cloud-browser-no-subfolders': 'This folder contains no more subfolders.',
		'cloud-browser-go-back': ' Please select the arrow to go back',
		'cloud-browser-open-button': 'Open',
		'cloud-browser-add-button': '+ Add',

		'company-create-title': 'What\'s the name of your company?',
		'company-create-placeholder': 'Company name',
		'company-create-button': 'Create',

		'creator-welcome-title': 'Welcome',
		'creator-welcome-description': 'to Xara for Teams',

		'smartfields-tab': 'Team SmartFields',
		'smartfields-description': 'SmartFields get automatically applied to dynamic fields included in templates.',
		'smartfields-info': 'SmartFields can auto-populate your documents with<br />personalized information, including name, phone number, email<br />address, and many more. Team admins can set Team<br />SmartFields that everyone in their team can implement.',
		'smartfields-error': 'Please check your entries',
		'smartfields-team-name': 'Team Name',
		'smartfields-team-name-placeholder': 'Team Name',
		'smartfields-email': 'Contact email',
		'smartfields-email-placeholder': 'Email address',
		'smartfields-email-invalid': 'Invalid email address',
		'smartfields-address': 'Address',
		'smartfields-address1-placeholder': 'Street name',
		'smartfields-city-placeholder': 'City',
		'smartfields-region-placeholder': 'State / Region',
		'smartfields-postcode-placeholder': 'Postcode',
		'smartfields-country-placeholder': 'Country',
		'smartfields-phone': 'Phone number',
		'smartfields-phone-placeholder': 'Phone number',
		'smartfields-phone-invalid': 'The phone number provided is not valid. Please enter a different number, using numbers and the - + ( ) characters.',
		'smartfields-website': 'Website',
		'smartfields-website-placeholder': 'https://www.yourdomain.com',
		'smartfields-website-invalid': 'Please enter a valid web link.',
		'smartfields-social-link-description': 'Link to your profile',
		'smartfields-social-name-description': 'Profile name (displayed in templates)',
		'smartfields-instagram': 'Instagram',
		'smartfields-instagram-link-placeholder': 'https://www.instagram.com/yourprofile',
		'smartfields-instagram-link-invalid': 'Please enter a valid web link e. g. www.instagram.com/your_profile/ .',
		'smartfields-instagram-name-placeholder': '@yourinstagramprofile',
		'smartfields-facebook': 'Facebook',
		'smartfields-facebook-link-placeholder': 'https://facebook.com/yourprofile',
		'smartfields-facebook-link-invalid': 'Please enter a valid web link e. g. www.facebook.com/your_profile/ .',
		'smartfields-facebook-name-placeholder': '@yourfacebookprofile',
		'smartfields-twitter': 'Twitter',
		'smartfields-twitter-link-placeholder': 'https://twitter.com/yourprofile',
		'smartfields-twitter-link-invalid': 'Please enter a valid web link e. g. www.twitter.com/your_profile/ .',
		'smartfields-twitter-name-placeholder': '@yourtwitterprofile',
		'smartfields-linkedin': 'LinkedIn',
		'smartfields-linkedin-link-placeholder': 'https://linkedin.com/yourprofile',
		'smartfields-linkedin-link-invalid': 'Please enter a valid web link e. g. www.linkedin.com/your_profile/ .',
		'smartfields-linkedin-name-placeholder': 'yourlinkedinprofile',

		'customize-header': 'Customize',
		'customize-home-screen': 'Home screen',
		'customize-files': '{0} files',
		'customize-documents': 'Documents',
		'customize-templates': 'Templates',
		'customize-assets': 'Assets',
		'customize-xara-templates': 'Xara templates',
		'customize-show-in-home-screen': 'Show in home screen',
		'customize-show-to-admins-only': 'Show to admins only',
		'customize-show-playbook-folders-to-admins-only': 'Show Playbook folders to admins only',
		'customize-editor': 'Editor',
		'customize-automatically-save-images-info': 'Only the images uploaded by the team admin will be saved. Assets are shared with all team members.',
		'customize-automatically-save-images': 'Automatically save images to assets',
		'customize-admins-only-publish-team-docs': 'Only admins can publish / delete team documents',
		'customize-admins-only-import-docs': 'Only admins can import documents',

		'customize-other': 'Other',
		'customize-default-print-document-recipient': 'Default print document recipient',
		'customize-default-print-document-recipient-info': 'This is the default email all team members see, when they send a print document through email',
		'customize-default-print-document-recipient-placeholder': 'Enter email address',
		'customize-text-field-save': 'Save',

		'customize-default-print-document-recipient-email-invalid': 'Please enter a valid email',
		'customize-default-print-document-recipient-email-the-same': 'Error: The new email is the same as the current.',


		'subscription-category-cloud': 'Cloud',
		'subscription-category-desktop': 'Desktop',

		'subscription-tag-desktop-only': 'Desktop only',
		'subscription-tag-cloud-only': 'Cloud only',
		'subscription-tag-cloud-and-desktop': 'Cloud + Desktop',

		'subscription-header': 'Billing & Plans',
		'subscription-current-plan': 'Your current plan:',
		'subscription-trial': ' Trial',
		'subscription-free': 'Free (trial expired)',
		'subscription-upgrade-options': 'Your upgrade options:',
		'subscription-period-selector-annual': 'Yearly',
		'subscription-period-selector-annual-discount': 'Up to 45% off',
		'subscription-period-selector-monthly': 'Monthly',
		'subscription-period-selector-perpetual': 'One-time purchase',
		'subscription-box-per-month': ' / mo',
		'subscription-box-yearly': 'yearly',
		'subscription-box-monthly': 'monthly',
		'subscription-box-billed': '{0}, billed {1}',
		'subscription-box-change-to-this-plan': 'Change to this plan',
		'subscription-box-upgrade': 'Upgrade',
		'subscription-box-subscribe': 'Subscribe now',
		'subscription-box-buy': 'Buy now',
		'subscription-box-view-current-plan': 'View current plan',
		'subscription-box-view-change-to-yearly-subscription': 'Change to yearly subscription',
		'subscription-box-more-info': 'More information',
		'subscription-box-less-info': 'Less information',
		'subscription-discount-magix': 'Magix customer?',
		'subscription-discount-get': 'Get discount now',
		'subscription-discount-applied': '{0}% off discount applied to your annual plans.',
		'subscription-discount-applied-perpetual': '{0}% off discount applied to your products.',
		'subscription-discount-applied-perpetual-generic': 'Discount has been applied to your products.',
		'subscription-discount-try-another-serial': 'Try another serial number',
		'subscription-no-upgrade-options': 'No further upgrade options available.<br />Thanks for choosing us!',
		'subscription-not-admin': 'You are not an admin of this team. Only admins are authorized to upgrade a subscription.<br />Let your team admin know that you would like to upgrade.',
		'subscription-notify-admin': 'Notify team admin',
		'subscription-admin-notified': 'Your admin was notified to upgrade the subscription.',
		'subscription-your-current-plan': 'Your current plan',
		
		'subscription-no-access-to-desktop-apps-plus': 'Any desktop products you might have activated (Designer Pro+, Photo & Graphic Designer+, Web Designer+)',
		'subscription-no-access-to-desktop-apps-perpetual': 'Any desktop products you might have activated (Designer Pro, Photo & Graphic Designer, Web Designer)',

		'subscription-continue-to-use-desktop-apps-plus': 'Demo Mode of desktop products you might have activated (Photo & Graphic Designer+, Web Designer+, Designer Pro+)',
		'subscription-continue-to-use-desktop-apps-perpetual': 'Demo Mode of desktop products you might have activated (Photo & Graphic Designer, Web Designer, Designer Pro)',

		'subscription-currency': 'Currency',
		'subscription-currency-usd': 'US Dollar',
		'subscription-currency-gbp': 'Pound Sterling',
		'subscription-currency-eur': 'Euro',
		
		'subscription-duration-lifetime': 'Lifetime',
		'subscription-total-licenses': 'Total licenses',
		'subscription-used-licenses': '{0} out of {1} licenses are in use.',
		'subscription-used-licenses-single-user': 'License is in use.',
		'subscription-used-licenses-single-user-not-used': 'License is not in use.',
		
		'subscription-user-licenses-stats': 'User licenses: {0} ({1} in use)',
		'subscription-total-users': 'Users',
		'subscription-single-user': 'Single user',
		'subscription-billing-total' : 'Billing total',
		'subscription-next-billing-issue-date': 'Next billing issue date',
		'subscription-current-billing-period-yearly': 'Billed yearly',
		'subscription-current-billing-period-monthly': 'Billed monthly',
		'subscription-calculating-renewal': 'Calculating...',
		'subscription-current-billing-period-perpetual': 'One-time purchase',
		'subscription-cancellation-date': 'Subscription will be canceled on {0}',
		're-subscription-cancellation-date': 'You are on a legacy plan. You will lose your discounted pricing once it cancels on {0}',
		'subscription-revoke-cancellation-info': 'To revoke cancellation, go to \'View details & manage\' > your plan > \'Remove scheduled cancellation\'.',
		'subscription-undo-cancellation-info-real-estate': 'To undo cancellation, click on \'Undo cancellation\' link below, go to \'View details & manage\' > your plan > \'Remove scheduled cancellation\'.',
		'subscription-reactivate-plan-info-real-estate': 'To resubscribe click on \'Reactivate plan\' link below.',

		'subscription-renewal-date': 'Subscription renewal date',
		'subscription-list-see-all-products': 'See all products',
		'subscription-no-products-found' : 'No products found',
		'subscription-action-view-details-and-manage': 'View details & manage',
		'subscription-action-add-more-seats': 'Purchase user licenses',
		'subscription-action-update-credit-card': 'Update credit card',
		'subscription-action-upgrade': 'Upgrade plan',
		'subscription-action-upgrade-now': 'Upgrade now',
		'subscription-action-update-seats': 'Update seats',
		'subscription-action-talk-to-sales': 'Talk to Sales',
		'subscription-action-upgrade-to-brokerage': 'Upgrade to Brokerage',
		'subscription-action-downgrade-to-individual-agent': 'Downgrade to Individual Plan',
		'subscription-switch-to-yearly-and-save': 'Switch to yearly subscription and save up to 45%!',
		'subscription-reactivate-my-plan': 'Reactivate my plan ({0})',
		're-packages-ends-on': 'Ends on',

		'subscription-billing-year': 'year',
		'subscription-billing-month': 'month',
		'subscription-including-vat': 'incl. VAT',
		'subscription-plus-vat': '+ VAT if applicable',
		'subscription-payment-methods-accepted': 'We accept',

		'subscription-got-questions-general': 'Got questions?',
		'subscription-contact-us': 'Contact us',
		'subscription-contact-support': 'Contact support',
		'subscription-contact-support-message': 'Hi Xara team, I have trouble using coupon {0}. It returns an error that says "{1}". Can you help me?',
		'subscription-contact-sales': 'Contact sales',
		'subscription-learn-more': 'Learn more',
		'subscription-get-a-quote': 'Get a quote',
		'subscription-need-a-bulk-discount': 'Need Bulk Discount?',

		'subscription-active-offers-cloud': 'See all active offers',
		'subscription-active-offers-perpetual': 'See all active offers for',

		'subscription-trial-expires-on': 'Trial expires on',
		'subscription-trial-you-have-full-access-to': 'After that, you will lose full access to',
		'subscription-free-you-can-continue-to-use': 'You can continue to use',
		'subscription-xara-cloud-free-plan': 'Xara Cloud Free Plan',
		'subscription-xara-cloud': 'Xara Cloud',
		'subscription-pending-subscription': 'Please wait, updating subscription status...',

		'subscription-confirm-choice-title': 'Confirm choice',
		'subscription-confirm-choice-selected': 'You have selected',
		'subscription-confirm-choice-licenses-total': '{0} license(s)',
		'subscription-confirm-choice-one-agent': '1 agent',
		'subscription-confirm-choice-users-total': '{0} user(s)',
		'subscription-confirm-choice-users-total-including-free': '{0} users ({1} included for free)',
		'subscription-confirm-choice-12-months-commitment': '12-month commitment',

		'subscription-confirm-choice-agents-total': '{0} agent(s)',
		'subscription-confirm-choice-agents-total-including-free': '{0} agents ({1} included for free)',

		'subscription-confirm-number-of-users-title': 'Confirm number of users',
		'subscription-confirm-number-of-users-description': '<p>Your team has {0} users currently, but you want to subscribe with {1} user license(s).</p><p>Please subscribe with no less than {0} user licenses, or reduce the current users on your team.</p>',

		'subscription-reduce-users-title': 'Reduce users',
		'subscription-reduce-users-description': 'The plan you choose allows you to have up to {0} users without extra cost. Please select what to do with each user.',
		'subscription-reduce-seats-remaining': 'You still need to reduce <span>{0}</span> admins / members.',
		'subscription-reduce-about-roles': 'About roles',
		'subscription-reduce-action-keep-role': 'Keep role',
		'subscription-reduce-action-change-to-guest': 'Change to guest',
		'subscription-reduce-action-remove': 'Remove',
		'subscription-reduce-reduce-users-action-info-keep-role': 'Keep role: user keeps the current role.',
		'subscription-reduce-reduce-users-action-info-change-to-guest': 'Change to guest: no access to team files, templates or assets. Can comment and collaborate on selected documents with limited editing capabilities.',
		'subscription-reduce-reduce-users-action-info-remove': 'Remove: user will be removed from the team and lose access to everything under this team.',

		'subscription-extra-licenses-title': 'Purchase extra licenses',
		'subscription-extra-licenses-quantity-label': 'Enter quantity',
		'subscription-extra-licenses-cost-per-license': '{0}{1} for each license.',
		'subscription-extra-licenses-discount-applied': 'Discount applied',
		'subscription-extra-licenses-discount-use': 'Use a coupon',
		'subscription-extra-licenses-change-coupon': 'Change coupon',

		'subscription-extra-users-title': 'Purchase user licenses',
		'subscription-extra-users-quantity-label': 'Enter quantity',
		'subscription-extra-users-total-users-after-purchase': 'Your team will have a total of {0} user licenses.',
		'subscription-extra-users-admin-member-usage': 'Each admin / member uses 1 user license.',
		'subscription-extra-users-role-info': 'A user can be an admin or a member.',
		'subscription-extra-users-total': 'Total',
		'subscription-extra-users-total-until-renewal': 'Total until renewal',
		'subscription-extra-users-seat-discount-applied': 'discount applied',

		'subscription-extra-users-calculating-total': 'Calculating...',
		'subscription-extra-users-error-calculating': 'Error fetching data.',

		'subscription-plan-tag-new': 'New',
		'subscription-plan-tag-coming-soon': 'Coming soon',
		'subscription-plan-tag-current-plan': 'Current plan',

		'subscription-ovhcloud-discount': '20% off website hosting plans with OVHcloud',

		'subscription-plan-essential-description': 'For teams. Deliver engaging content, always on-brand.',
		'subscription-plan-essential-options-title': 'All the features in your free plan, plus...',
		'subscription-plan-essential-options-title-active': 'All the features in your current plan, plus...',
		'subscription-plan-essential-includes-1': '3 seats included',
		'subscription-plan-essential-includes-1-tooltip': 'Invite up to 2 team members for free',
		'subscription-plan-essential-includes-2': 'Unlimited guests included',
		'subscription-plan-essential-bullet-brand-kit-title': 'Brand kit & auto-branding',
		'subscription-plan-essential-bullet-brand-kit-description': 'Automatically brand your content & keep everyone on-brand by enforcing brand standards.',
		'subscription-plan-essential-bullet-document-resizing-title': 'One-click document re-sizing',
		'subscription-plan-essential-bullet-document-resizing-description': 'Resize a doc into different formats for other channels.',
		'subscription-plan-essential-bullet-social-media-title': 'Publish to all social media channels',
		'subscription-plan-essential-bullet-social-media-description': 'Resize a doc into different formats for other channels.',
		'subscription-plan-essential-bullet-ai-title': 'AI Social Media Post Writer',
		'subscription-plan-essential-bullet-ai-description': 'Generate engaging social media posts tailored to your audience in seconds.',
		'subscription-plan-essential-bullet-shared-assets-title': 'Shared Asset Library',
		'subscription-plan-essential-bullet-shared-assets-description': 'Store, share and keep all your approved design components',
		'subscription-plan-essential-bullet-import-export-title': 'Import & Export PDF, PPT, Word, PNG, JPG, and more.',
		'subscription-plan-essential-bullet-import-export-description': 'Edit and improve your brand\'s current documents and designs.',
		'subscription-plan-essential-bullet-try-for-free-title': 'Try Xara AI for free',
		'subscription-plan-essential-bullet-try-for-free-description': '<span>100 complimentary credits</span><span>Write high-quality text, fix errors, and translate your content in seconds.</span>',

		'subscription-plan-scale-description': 'Scale your brand\'s content, & measure performance.',
		'subscription-plan-scale-description-desktop': 'Transform designs into brand experiences and automate marketing workflows with our Cloud Platform',

		'subscription-plan-scale-options-title': 'All the features in Essential, plus...',
		'subscription-plan-scale-options-title-desktop': 'Pair Designer Pro+ with Xara Cloud:',

		'subscription-plan-scale-includes-1': '3 seats included',
		'subscription-plan-scale-includes-1-tooltip': 'Invite up to 2 team members for free',
		'subscription-plan-scale-includes-2': 'Unlimited guests included',
		'subscription-plan-scale-tag': 'Most productive',
		'subscription-plan-scale-list-main-1': 'Work online with Xara Cloud',
		'subscription-plan-scale-list-main-2': 'Collaborate with your team',
		'subscription-plan-scale-list-main-3': 'Automatically brand content',
		'subscription-plan-scale-list-main-4': 'Easily find and manage your content',
		'subscription-plan-scale-list-main-5': 'Turn one design into many formats with a click',
		'subscription-plan-scale-list-main-6': 'Post directly to all social media channels',
		'subscription-plan-scale-section-ai-title': 'XARA AI included',
		'subscription-plan-scale-section-ai-description': '100 credits per month.',
		'subscription-plan-scale-bullet-ai-writter-title': 'AI Writer & reviewer',
		'subscription-plan-scale-bullet-ai-writter-description': 'Write, review and deliver your marketing in seconds, not hours.',
		'subscription-plan-scale-bullet-ai-translator-title': 'AI Translator',
		'subscription-plan-scale-bullet-ai-translator-description': 'Immediately localize your content and reach audiences in their language.',

		'subscription-plan-scale-section-collaborate-title': 'Collaborate at scale',
		'subscription-plan-scale-bullet-library-title': 'Company Template & Asset Library',
		'subscription-plan-scale-bullet-library-description': 'Let everyone personalize ready-to-go content with a centralized library of branded templates and assets.',
		'subscription-plan-scale-bullet-template-modification-title': 'Define how templates are modified',
		'subscription-plan-scale-bullet-template-modification-description': 'Control template modifications with template and object locking.',
		'subscription-plan-scale-bullet-user-roles-title': 'Define user roles: Admins, members, guests.',
		'subscription-plan-scale-bullet-user-roles-description': 'Assign specific roles and access levels: Admin, Member, or Guest.',
		'subscription-plan-scale-bullet-member-access-title': 'Customize what members can see',
		'subscription-plan-scale-bullet-member-access-description': 'Manage what types of template member can access',
		'subscription-plan-scale-bullet-approved-media-title': 'Work with approved media only',
		'subscription-plan-scale-bullet-approved-media-description': 'Ensure brand consistency by using only pre-approved media assets',
		'subscription-plan-scale-bullet-approved-templates-title': 'Give your team approved templates',
		'subscription-plan-scale-bullet-approved-templates-description': 'Ensure everyone\'s creating on-brand marketing with vetted templates.',
		'subscription-plan-scale-bullet-analytics-title': 'Viewer analytics',
		'subscription-plan-scale-bullet-analytics-description': 'Publish interactive documents online and gather reader engagement insights.',
		'subscription-plan-scale-section-content-assistance-title': 'Template & Content assistance',
		'subscription-plan-scale-bullet-curated-library-title': 'Your Template Library Set up by Experts',
		'subscription-plan-scale-bullet-curated-library-description': 'Get a professionally curated template library, tailored for your brand and company needs.',

		'subscription-plan-enterprise-description': 'Need multiple teams? Enterprise Features? Can\'t find a matching requirement?',
		'subscription-plan-enterprise-includes': 'Invite up to 2 teammates for free.',
		'subscription-plan-enterprise-options-title': 'All the features in Scale, plus...',
		'subscription-plan-enterprise-price': 'Custom',

		'subscription-plan-enterprise-bullet-flexible-pricing-title': 'Usage based pricing',
		'subscription-plan-enterprise-bullet-flexible-pricing-description': 'Flexible pricing that scales with your team\'s usage.',
		'subscription-plan-enterprise-bullet-unlimited-storage-title': 'Unlimited Storage',
		'subscription-plan-enterprise-bullet-unlimited-storage-description': 'Store all your assets without any limitations.',
		'subscription-plan-enterprise-bullet-sso-title': 'SSO',
		'subscription-plan-enterprise-bullet-sso-description': 'Secure single sign-on for simplified access across your organization.',
		'subscription-plan-enterprise-bullet-custom-integration-title': 'Custom Integrations',
		'subscription-plan-enterprise-bullet-custom-integration-description': 'Integrate seamlessly with your existing enterprise tools.',
		'subscription-plan-enterprise-bullet-multi-team-title': 'Multi-team management',
		'subscription-plan-enterprise-bullet-multi-team-description': 'Manage multiple teams and projects under one umbrella.',
		'subscription-plan-enterprise-bullet-api-title': 'API & White Label Platform',
		'subscription-plan-enterprise-bullet-api-description': 'Customize the platform with your branding for a cohesive experience',
		'subscription-plan-enterprise-bullet-playbooks-title': 'Custom Playbooks',
		'subscription-plan-enterprise-bullet-playbooks-description': 'Automated workflows tailored to your business needs and strategies.',
		'subscription-plan-enterprise-section-self-service-title': 'Self-service portal',
		'subscription-plan-enterprise-bullet-campaign-posting-title': 'Direct campaign posting & download',
		'subscription-plan-enterprise-bullet-campaign-posting-description': 'Deliver ready-to-share content for everyone to post, print and publish effortlessly',
		'subscription-plan-enterprise-bullet-community-campaigns-title': 'Community engagement campaigns',
		'subscription-plan-enterprise-bullet-community-campaigns-description': 'Increase brand reach, engagement and employee thought leadership.',
		'subscription-plan-enterprise-section-template-assistance-title': 'Template & Content assistance',
		'subscription-plan-enterprise-bullet-library-setup-title': 'Your Template Library Set up by Experts',
		'subscription-plan-enterprise-bullet-library-setup-description': 'Professionally designed templates customized for your brand.',
		'subscription-plan-enterprise-bullet-template-updates-title': 'Monthly Template Updates',
		'subscription-plan-enterprise-bullet-template-updates-description': 'Keep your content fresh with regular template additions, improvements and requests.',
		'subscription-plan-enterprise-bullet-strategy-definition-title': 'Strategy Definition',
		'subscription-plan-enterprise-bullet-strategy-definition-description': 'Define your content strategy with expert assistance',
		'subscription-plan-enterprise-bullet-personalized-training-title': 'Personalized Training & Onboarding',
		'subscription-plan-enterprise-bullet-personalized-training-description': 'Tailored training programs to get your team up to speed quickly',

		'subscription-plan-web-description': 'Design and launch websites you are proud of. Unlimited creation and customization without coding hassles.',
		'subscription-plan-web-includes': 'Per single user',
		'subscription-plan-web-options-title' : 'What\'s included?',
		'subscription-plan-web-list-main-1': 'Unlimited websites included',
		'subscription-plan-web-list-main-2': 'WYSIWYG Drag-and-Drop editor',
		'subscription-plan-web-list-main-3': 'Fast & responsive design',
		'subscription-plan-web-list-main-4': 'Live prototyping and multi-version creation',
		'subscription-plan-web-list-main-5': 'Built-in graphics editor and optimization',
		'subscription-plan-web-list-main-6': 'SEO, marketing, and e-commerce tools',
		'subscription-plan-web-list-main-7': 'Ever-growing template and asset library',
		'subscription-plan-web-list-main-8': 'Google Drive, Dropbox & OneDrive integration',

		'subscription-plan-photo-description': 'Combine all your photo editing and illustration tools into one simple workflow.',
		'subscription-plan-photo-includes': 'Per single user',
		'subscription-plan-photo-options-title': 'What\'s included?',
		'subscription-plan-photo-list-main-1': 'Advanced photo manipulation & color correction',
		'subscription-plan-photo-list-main-2': 'Multi-layer compositions',
		'subscription-plan-photo-list-main-3': 'Background remover & Magic Erasing',
		'subscription-plan-photo-list-main-4': 'Intelligent image scaling',
		'subscription-plan-photo-list-main-5': 'High-quality vector illustration',
		'subscription-plan-photo-list-main-6': 'Infinite undo & redo',
		'subscription-plan-photo-list-main-7': 'Ever-growing template, live effects & asset library',
		'subscription-plan-photo-list-main-8': 'Google Drive, Dropbox & OneDrive integration',

		'subscription-plan-designer-description': 'Create with unlimited flexibility. Desktop publishing, web design, photo-editing, and graphic design – all in one place.',
		'subscription-plan-designer-includes': 'Per single user',
		'subscription-plan-designer-options-title': 'What\'s included?',
		'subscription-plan-designer-list-main-1': 'Unlimited websites included',
		'subscription-plan-designer-list-main-2': 'WYSIWYG Drag-and-Drop editor',
		'subscription-plan-designer-list-main-3': 'Fast & responsive design',
		'subscription-plan-designer-list-main-4': 'Live prototyping and multi-version creation',
		'subscription-plan-designer-list-main-5': 'Built-in graphics editor and optimization',
		'subscription-plan-designer-list-main-6': 'SEO, marketing, and e-commerce tools',
		'subscription-plan-designer-list-main-7': 'Ever-growing template and asset library',
		'subscription-plan-designer-list-main-8': 'Google Drive, Dropbox & OneDrive integration',

		'subscription-plan-web-per-description': 'Design and customize websites.',
		'subscription-plan-web-per-includes': 'Per single user',
		'subscription-plan-web-per-list-main-1': 'Fast & responsive web design',
		'subscription-plan-web-per-list-main-2': 'Basic set of text, illustration, and photo tools',
		'subscription-plan-web-per-list-main-3': 'Publish to any hosting provider',
		'subscription-plan-web-per-list-main-4': 'Template library and blocks not included',
		'subscription-plan-web-per-list-main-5': 'Released in 2023',

		'subscription-plan-photo-per-description': 'Photo editing and illustration tools in one platform.',
		'subscription-plan-photo-per-includes': 'Per single user',
		'subscription-plan-photo-per-list-main-1': 'Advanced photo editing tools',
		'subscription-plan-photo-per-list-main-2': 'Easy, high-quality vector design',
		'subscription-plan-photo-per-list-main-3': 'Powerful text tools for design and layout',
		'subscription-plan-photo-per-list-main-4': 'Elements (formerly Online Content Catalog) not included',
		'subscription-plan-photo-per-list-main-5': 'Released in 2023',

		'subscription-plan-designer-per-description': 'One product for all your graphic and web design needs.',
		'subscription-plan-designer-per-includes': 'Per single user',
		'subscription-plan-designer-per-list-main-1': 'Desktop publishing',
		'subscription-plan-designer-per-list-main-2': 'Advanced photo editing',
		'subscription-plan-designer-per-list-main-3': 'Vector drawing',
		'subscription-plan-designer-per-list-main-4': 'Website Builder (no coding)',
		'subscription-plan-designer-per-list-main-5': 'Elements (formerly Online Content Catalog) not included',
		'subscription-plan-designer-per-list-main-6': 'Released in 2023',

		'subscription-ribbon-save-money': 'save money',
		'subscription-ribbon-creativity': 'power up your creativity',
		'subscription-ribbon-popular': 'popular',
		'subscription-ribbon-best-value': 'best value',

		'subscription-successful-not-found': 'Updating, please wait a moment.',
		'subscription-successful-thanks': 'Thanks for subscribing!',
		'purchase-successful-thanks': 'Thanks for your purchase!',

		'subscription-successful-upgraded-to': 'You have successfully upgraded to',
		'subscription-successful-purchased': 'You have successfully purchased',
		'subscription-successful-upgraded': 'You have successfully upgraded.',
		'subscription-successful-see-plans': 'See Billing & Plans',
		'subscription-successful-start-creating': 'Start creating',
		'subscription-successful-download-products': 'Download product',
		'subscription-successful-activation-email': 'Please use <strong>{0}</strong> when activating your product.',

		'subscription-promo-section-apply': 'Apply discount',
		'subscription-promo-section-apply-coupon': 'apply coupon',
		'subscription-promo-section-applied': 'Applied',
		'subscription-coupon-code-placeholder': 'COUPON CODE',
		'subscription-saving-regular-price': 'Regular price',
		'subscription-saving-you-save': 'You save',
		'subscription-amount-per-month': 'Month',
		'subscription-amount-per-year': 'Year',
		'subscription-your-products-tab': 'My Products and Plan',
		'subscription-purchase-options-tab': 'Purchase Options',
		'subscription-price-for-number-of-licenses': 'for {0} licenses',
		'subscription-billed-annually-as-one-payment-of': 'Billed annually as one payment of',
		'subscription-calculating-price': 'Please wait, fetching price...',

		'subscription-your-producs-buy-more-licenses': 'Purchase extra licenses',

		'saving-subscription-per-year': 'You save <strong>{0}</strong> per year on your subscription with your discount.',
		'saving-subscription-per-month': 'You save <strong>{0}</strong> per month on your subscription with your discount.',
		'saving-subscription-per-limited-period': 'You save <strong>{0}</strong> for limited period with your discount.',
		'saving-subscription-per-year-first-order-only': 'You save <strong>{0}</strong> on the first year of your subscription with your discount.',
		'saving-subscription-per-month-first-order-only': 'You save <strong>{0}</strong> on the first month of your subscription with your discount.',
		'saving-once-off': 'You save <strong>{0}</strong> with your discount.',
		'saving-once-off-per-limited-period': 'You save <strong>{0}</strong> with your discount.',

		'subscriptions-modal-fetching-data': 'Please wait, updating seats...',
		'subscriptions-modal-updating-users': 'Please wait, updating users...',

		'subscriptions-error-unknown': 'An unknown error occurred, please try again or contact support.',
		'subscriptions-error-offline': 'Error: Cannot reach server. Please check your network connection and try again in a few seconds.',
		'subscriptions-error-invalid-numbers-of-users': 'Error: The number of the users cannot be less than the number of users in the company',
		'subscriptions-error-invalid-coupon-code': 'Error: Invalid coupon id.',
		'subscriptions-error-failed-to-retrieve-coupon': 'Error: Failed to retrieve coupon.',
		'subscriptions-error-coupon-does-not-exist': 'Error: Coupon code does not exist.',
		'subscriptions-error-coupon-does-not-qualify-for-any-product': 'Error: Coupon does not qualify for any of the products.',
		'subscriptions-error-coupon-does-not-qualify-for-this-product': 'Error: Coupon does not qualify for this product.',
		'subscriptions-error-coupon-does-not-qualify-fallback': 'This coupon only applies to {0}. We\'ve found a coupon for your selected product: {1}',
		'subscriptions-error-coupon-does-not-qualify-fallback-1': 'This coupon only applies to {0}',
		'subscriptions-error-coupon-does-not-qualify-fallback-2': 'We\'ve found a coupon for your selected product: {0}',
		'subscriptions-error-coupon-does-not-qualify-view-products': 'view products',
		'subscriptions-error-applicable-to-products-in-different-currency': 'Coupon qualifies only for products in currency:',
		'subscriptions-error-applicable-to-this-product-in-different-currency': 'Coupon qualifies for this products in currency:',
		'subscriptions-error-coupon-code-expired': 'Error: Coupon code expired.',
		'subscriptions-error-coupon-code-is-serial-number': 'Error: Product serial number is not valid coupon code.',
		'subscriptions-error-coupon-one-time-already-used': 'Error: One time coupon has already been used.',
		'subscriptions-error-cannot-replace-existing-coupon': 'Error: Another coupon has already been applied to your account. Please contact support to resolve the issue.',
		'subscriptions-error-segment-disabled': 'Please contact us at support@xara.com',
		'subscriptions-error-reduce-users-invalid-coupon': 'Invalid coupon. Checkout will proceed without coupon being applied.',

		'addons-section-title': 'Add-ons',

		'addon-ai-title': 'Get More XARA AI Credits',
		'addon-ai-description': 'Gives Essential & Scale teams more Xara AI credits.',
		'addon-ai-details': 'Add unlimited credits to your Essential or Scale plan for {0}8 per team / month (annually). {0}10 per team / month (monthly)',
		'addon-ai-details-list-1': 'Write with AI',
		'addon-ai-details-list-2': 'Find and fix grammar, image & document errors',
		'addon-ai-details-list-3': 'Improve your writing',
		'addon-ai-details-list-4': 'Translate your documents',
		'addon-ai-details-list-5': 'Add more credits to your document generator*',
		'addon-ai-details-list-note': '* The Document Generator is available for Real Estate Users on the Scale Plan',

		'addon-cloud-storage-title': 'Cloud storage',
		'addon-cloud-storage-description': 'Gives Essential & Scale teams more Xara Cloud Storage.',
		'addon-cloud-storage-details': 'Starting at {0}5 / 100 GB / month',

		'addon-design-service-title': 'Design service',
		'addon-design-service-description': 'Professional-looking templates for your marketing activities.',
		'addon-design-service-details': 'By request',
		'addon-design-service-tag': 'For Real Estate',

		'addon-hosting-title': 'OVHcloud Hosting (20% Off)',
		'addon-hosting-description': 'Publish Your Website Easily. Xara users get 20% off OVHCloud hosting plans.',
		'addon-hosting-details-list-1': 'Domain name and SSL certificate',
		'addon-hosting-details-list-2': 'Up to 500GB of storage',
		'addon-hosting-details-list-3': 'Email accounts for your domain',
		'addon-hosting-details-subscription': 'Web Designer+ and Designer Pro+',
		'addon-hosting-details-perpetual': 'Web Designer v20 and Designer Pro v20',
		'addon-hosting-button-label': 'Get your discount code',

		'addon-intercom-message-ai': 'Hey Xara Team, I\'d like to add unlimited AI Credits to my workspace, can we activate this?',
		'addon-intercom-message-cloud-storage': 'Hey Xara Team, I would like to add more storage space to my workspace, how much does it cost?',
		'addon-intercom-message-design-services': 'Hey Xara Team, I will need help creating or improving my documents. I\'m in [Enter Industry] and I use [Enter type of content] to reach my clients. Can you get in touch with me?',
		'addon-intercom-message-mls': 'Hey Xara Team, I\'m interested in auto-filling my docs with the MLS addon. My MLS is [MLS NAME], it\'s website is [MLS WEBSITE URL], and I have [NUMBER] agents.',

		'discount-modal-title': 'Check your eligible discount',
		'discount-modal-email-placeholder': 'Enter email for Magix license',
		'discount-modal-email-invalid': 'Invalid email address',
		'discount-modal-serial-placeholder': 'Enter product serial number',
		'discount-modal-serial-invalid-format': 'Serial number is in invalid format.',
		'discount-modal-checking': 'Checking your credential',
		'discount-modal-success-title': 'Here\'s your {0}% OFF coupon!',
		'discount-modal-success-title-generic': 'Here\'s your coupon!',
		'discount-modal-success-message-subscription': 'Coupon will be applied automatically when you purchase a subscription plan.',
		'discount-modal-success-message-perpetual': 'Coupon will be applied automatically when you purchase a desktop product.',
		'discount-modal-invalid-serial': 'This license key doesn\'t look right. Please check and try again.',
		'discount-modal-serial-email-missmatch': 'This license key and email address don\'t match. Please check and try again.',
		'discount-modal-error-offline': 'Cannot reach server. Please check your network connection and try again in a few seconds.',
		'discount-modal-error-crs-info-request-failed': 'Internal Error. Please <a target="_blank" href="https://www.xara.com/contact-us/" underline="always">contact support</a>',
		'discount-modal-error-crs-invalid-credentials': 'No credentials found. Please check your information and try again or <a target="_blank" href="https://www.xara.com/contact-us/" underline="always">contact support</a>',
		'discount-modal-error-crs-credentials-already-used': 'Discount code has already been used for these credentials.',
		'discount-modal-error-unknown': 'An unknown error occurred.',
		'discount-modal-serial-number-format-example': 'Serial number needs to be in one of the following formats:',

		're-packages-slider-title': 'How many agents are in your brokerage?',
		're-packages-slider-subtitle': 'Move the slider to adjust your team size and see pricing. All plans require a 12-month commitment.',

		're-packages-choose-team-size': 'Choose a team size to view pricing.',
		're-packages-per-month': 'per month',
		're-packages-per-agent': 'per agent',
		're-packages-lets-talk': 'Let\'s Talk', 
		're-packages-custom-pricing': 'Custom pricing for large teams.',

		're-packages-legend-agent': '{0} agent',
		're-packages-legend-agents': '{0} agents',
		're-packages-legend-up-to-agents': 'Up to {0} agents',
		're-packages-legend-label': 'Agents',
		're-packages-legend-click-info': 'Click the number to type',
		're-packages-legend-save-info': 'Press Enter to apply, Esc to cancel',

		'package-individual-agents-title': 'For Individual Agents',
		'package-individual-agents-tag': 'Solo agent',
		'package-individual-agents-subtitle': 'Everything you need to promote listings and grow your brand.',

		'package-individual-agents-feature-1': 'Auto-post listings and expert content daily on Facebook, LinkedIn, and Instagram',
		'package-individual-agents-feature-2': 'Automatic marketing campaign generation',
		'package-individual-agents-feature-3': 'Unique local expert content, 7 posts per week',
		'package-individual-agents-feature-4': 'Branded print materials',
		'package-individual-agents-feature-5': 'Send listing email campaigns with 1 click',
		'package-individual-agents-feature-5-description': 'Works with: Follow Up Boss, Brevo, Constant Contact',
		'package-individual-agents-feature-6': 'Custom designs matching your brand',

		'package-individual-agents-what-you-get-title': 'What You Get',

		'package-individual-agents-what-you-get-1': 'Every listing marketed across all channels automatically',
		'package-individual-agents-what-you-get-2': 'Consistent social presence without daily work',
		'package-individual-agents-what-you-get-3': 'Professional brand appearance across all materials',
		'package-individual-agents-what-you-get-4': 'More buyer inquiries per listing',

		'package-brokerages-title': 'For Brokerages',
		'package-brokerages-tag': 'Multiply agent success',
		'package-brokerages-subtitle': 'Choose a team size to view pricing.',

		'package-brokerages-section-1-title': 'Listing Marketing Automation',
		'package-brokerages-section-1-description': 'Help agents sell faster without adding staff or tools.',
		'package-brokerages-section-1-feature-1-title': 'Delivers personalized marketing materials for every agent',
		'package-brokerages-section-1-feature-1-description': 'Detects new and updated MLS listings automatically.',
		'package-brokerages-section-1-feature-2-title': 'Promotes listings across each agent\'s social media profiles',
		'package-brokerages-section-1-feature-3-title': 'Includes print-ready flyers, postcards, and mailers for every property',
		
		'package-brokerages-section-2-title': 'Social Media Management',
		'package-brokerages-section-2-description': 'Automatically promote your agents\' listings and your brand across every channel.',
		'package-brokerages-section-2-feature-1-title': 'Schedules and posts listings for each agent',
		'package-brokerages-section-2-feature-2-title': 'Positions agents as experts with curated content',
		'package-brokerages-section-2-feature-3-title': 'Agent and agency level profiles',
		'package-brokerages-section-2-feature-4-title': 'Central content library',

		'package-brokerages-section-3-title': 'Email Marketing',
		'package-brokerages-section-3-description': 'Showcase listings and reach more clients with automated emails.',
		'package-brokerages-section-3-feature-1-title': 'Branded email templates',
		'package-brokerages-section-3-feature-2-title': 'MLS listing email campaigns',
		'package-brokerages-section-3-feature-3-title': 'Open and click analytics',

		'package-brokerages-section-4-title': 'Brokerage Support',
		'package-brokerages-section-4-description': 'Setup, integration, and ongoing help so your team stays focused on sales.',
		'package-brokerages-section-4-feature-1-title': 'White glove onboarding',
		'package-brokerages-section-4-feature-2-title': 'Integration assistance',
		'package-brokerages-section-4-feature-3-title': 'Priority support',

		'package-brokerages-upgrade-intercom-message':  `Hi there 👋 I’d like to buy Xara for my brokerage.\nI currently manage about {0} agents in my brokerage and we'd like to discuss custom pricing.\nMy email is {1}. \nCould someone from sales help me set up a plan for {0} users?`,
		'package-brokerages-downgrade-intercom-message':  `Hi there 👋 I’d like to downgrade from Brokerage to Individual Agent package. My email is {0}. \nCould someone from sales help me with downgrade?`,
		'package-brokerages-downgrade-seats-message':  `Hi there 👋 I’d like to downgrade from {0} to {1} agent(s). My email is {2}. \nCould someone from sales help me with downgrade?`,

		're-packages-add-more-seats': 'Your plan will be updated to {0} seats. Proration applies. Your new price {1}',
		're-packages-add-more-seats-difference': 'Increase my plan from {0} to {1} users.',
		're-packages-add-more-seats-new-price': 'Your new price {0}.',

		're-packages-next-billing': 'Next billing',
		're-packages-status': 'Status',
		're-packages-status-active': 'Active',
		're-packages-status-cancelled': 'Cancelled',
		're-packages-status-pending-cancellation': 'Scheduled cancellation',
		're-packages-manage-payment-method': 'Manage payment method',
		're-packages-view-invoices': 'View invoices',
		're-packages-cancel-plan': 'Cancel plan',
		're-packages-reactivate-plan': 'Reactivate plan',
		're-packages-plan-disabled': 'Not available',
		're-packages-revoke-cancellation': 'Undo cancellation',

		're-upgrade-to-brokerage-to-add-more-users': 'On this plan you can add only Guests. Please upgrade to Brokerage plan to add admins and members.',

		're-packages-success-purchasing-seats': 'Thank you for your purchase! Your seats have been successfully purchased.',

		'download-header': 'Download',
		'download-description1': 'Take your designs to the next level with our photo editing, illustration, and web design tools.',
		'download-description2': 'Get all the capabilities in one place with Designer Pro+.',
		'download-description3': '(Desktop application for Windows only)',
		'download-download': 'Download {0}',
		'download-find-out-more': 'Find out more',
		'download-you-own-this-product': 'You own this product',

		'account-header': 'Sign-in details',
		'account-current-password-description': 'To make changes, please verify your password',
		'account-current-password-placeholder': 'Current password',
		'account-current-password-button': 'Verify',
		'account-email-label': 'Sign in email ',
		'account-email-placeholder': 'Email',
		'account-email-button': 'Change Email',
		'account-email-invalid': 'Invalid email address',
		'account-email-the-same': 'Error: The new email is the same as the current.',
		'account-name-label': 'Name ',
		'account-name-first-placeholder': 'First name',
		'account-name-last-placeholder': 'Last name',
		'account-name-button': 'Change Name',
		'account-name-consecutive-spaces': 'You may not have multiple consecutive spaces.',
		'account-name-first-leading-trailing-spaces': 'You may not have a first name that starts or ends with space.',
		'account-name-last-leading-trailing-spaces': 'You may not have a last name that starts or ends with space.',
		'account-password-label': 'Password ',
		'account-password-description': 'Please choose a password, between {0} and {1} characters long',
		'account-password-placeholder': 'New password',
		'account-password-repeat-placeholder': 'Repeat new password',
		'account-password-button': 'Change Password',
		'account-password-too-short': 'Password should have at least {0} characters.',
		'account-password-too-long': 'Password should have no more than {0} characters.',
		'account-password-popup-title': 'Set password',
		'account-password-popup-message': 'For security, Xara Cloud requires you to set a password to make changes to your sign-in details.<br/><br/> Xara Cloud will send an email to {0} to verify your account. You may need to check your spam folder.',
		'account-password-popup-button': 'Send Email',
		'account-confirm-email-popup-title': 'Confirm your email address',
		'account-confirm-email-popup-message': 'We sent an email to <b>{0}</b> with a link. To confirm this change please click the link in the email. Until you do this your account will still use <b>{1}</b>.',
		'account-reset-password-success': 'An email has been sent to the provided email address, please check your inbox.',
		'account-reset-password-error': 'An error occurred, please reload page and try again. If the problem continues, contact us.',
		'account-new-email-success': 'An email has been sent to the new email address, please check your inbox.',
		'account-error-offline': 'Error: Cannot reach server. Please check your network connection and try again in a few seconds.',
		'account-error-invalid-password': 'Error: The provided password is invalid.',
		'account-error-passwords-not-matching': 'Error: The provided passwords do not match.',
		'account-error-password-already-used': 'Error: Could not update your password: the new one is the same as the current.',
		'account-error-wrong-password': 'Error: The password is incorrect',
		'account-error-email-already-used': 'Error: The new email is the same as the current.',
		'account-error-invalid-email-format': 'Error: Invalid email format.',
		'account-error-invalid-first-name': 'Error: Invalid first name.',
		'account-error-invalid-last-name': 'Error: Invalid last name.',
		'account-error-unknown-email': 'Error: We couldn\'t find an account with the email you entered.',
		'account-error-email-associated-to-another-user': 'Error: New email is already associated to another user.',
		'account-error-notification-service-internal-error': 'Error: Failed to send share email to the following email addresses. Please correct the addresses or try again later.',
		'account-error-unknown': 'An unknown error occurred, please try again.',

		'contact-sales-form-title' : 'Contact our Sales Team',
		'contact-sales-form-title-bulk-discount' : 'Ask for a bulk price',

		'contact-sales-form-first-name': 'First name',
		'contact-sales-form-last-name': 'Last name',
		'contact-sales-form-company-name': 'Company name',
		'contact-sales-form-number-of-users': 'Number of users',
		'contact-sales-form-number-of-users-select': 'Please select',
		'contact-sales-form-work-email': 'Work email',
		'contact-sales-form-job-title': 'Job Title',
		'contact-sales-form-phone-number': 'Phone number',
		'contact-sales-form-usage-info': 'Tell us about your team, workflow, and goals for using Xara Cloud so we can connect you to the best representative.',
		'contact-sales-form-demo-link': 'Skip & get on a 1-on-1 DEMO',
		'contact-sales-form-submit': 'Submit',
		'contact-sales-email-invalid': 'Invalid email address',
		'contact-sales-phone-invalid': 'The phone number provided is not valid. Please enter a different number, using numbers and the - + ( ) characters.',
		'contact-sales-please-errors-found-in-the-form': 'There\'s an issue with one or more fields.',
		'contact-sales-saving-form': 'Please wait, sending data...',
		'contact-sales-error-unknown': 'An unknown error occurred.',
		'contact-sales-error-offline': 'Cannot reach server. Please check your network connection and try again in a few seconds.',

		'contact-sales-form-success-title' : 'Speak Soon!',
		'contact-sales-form-success-description' : 'We got your message and a representative will get in touch soon. If you need a quick 1-on-1 right now, please <a href="#">check our availability here!</a>',

		'mls-connection-header': 'MLS connection',
		'mls-connection-popup-header': 'Connect MLS',
		'custom-mls-connection-popup-header': 'Tell us which MLS you use',

		'mls-add-button': 'Add MLS',
		
		'mls-office-popup-header': 'Add MLS office',
		'mls-office-popup-description': 'Add an office to <strong>{0}</strong>.<br><br>If you have multiple offices, add one at a time.',
		
		'mls-manage-agents-popup-header': 'Manage agent MLS connection',
		'mls-manage-agents-popup-add-users-1': 'Add users',
		'mls-manage-agents-popup-add-users-2': 'if they are not yet in the team.',

		'mls-popup-connect': 'Connect',
		'mls-popup-submit-request': 'Submit connection request',
		'mls-popup-sending-request': 'Sending',

		'mls-connection-popup-mls-not-in-the-list': 'My MLS is not in the list',
		'mls-popup-contact-us': 'Contact us',

		'your-mls-label': 'Your MLS',
		'your-mls-placeholder': 'Please select or type',

		'mls-connect-with-label': 'Connect with',
		'mls-office-id-label': 'MLS office ID',
		'mls-agent-id-label': 'Agent MLS ID',
		'mls-listing-number-label': 'Listing MLS number (optional)',
		'mls-office-id-placeholder': 'Enter an MLS office ID',
		'mls-agent-id-placeholder': 'Enter your agent MLS ID',
		'mls-office-other-placeholder': 'E.g. Office 01, Office 02',
		'mls-listing-number-placeholder': 'Enter one listing MLS number to test connection',
		'mls-search-for-agent-placeholder': 'Search for user name or email',
		'mls-clear-search': 'Clear search',

		'mls-please-select-mls-connection': 'Please select MLS connection',

		'mls-popup-saving-form': 'Please wait, sending data...',
		'mls-popup-errors-found-in-the-form': 'There\'s an issue with one or more fields.',

		'mls-connection-success-screen-title': 'MLS connected',
		'mls-connection-success-screen-description': 'You can now auto-generate materials in bulk with <strong>Playbooks</strong>.',
		'mls-connection-success-screen-run-playbooks': 'Run Playbooks',

		'mls-request-success-screen-title': 'We\'ll get in touch!',
		'mls-request-success-screen-description': 'Your automated marketing is on its way!<br><br>We will contact you regarding your MLS connection. Keep an eye on your email inbox in the upcoming days.',
		'mls-request-success-screen-got-it': 'Got it',
		'mls-request-success-screen-close': 'Close',

		'mls-office-success-screen-title': 'Office added',
		'mls-office-success-screen-description': 'Office <strong>{0}</strong> has been added to <strong>{1}</strong>.',

		'mls-error-manage-agents-screen-title-no-listings-found': 'Please check ID validity',
		'mls-error-manage-agents-no-listings-found': 'Agent MLS ID <strong>{0}</strong> is saved, but we couldn\'t find any recent listings for this agent in <strong>{1}</strong>.<br><br>As soon as a listing is added for this agent, we\'ll automatically detect it and run Playbooks.',
		'mls-error-manage-agents-no-listings-found-force-addition': 'Error saving MLS ID <strong>{0}</strong> in <strong>{1}</strong>.',

		'mls-error-connection-screen-title': 'Couldn\'t connect your MLS',
		'mls-error-connection-screen-title-no-listings-found': 'Review needed',

		'mls-error-office-screen-title': 'Couldn\'t add office',
		'mls-error-screen-contact-for-help-1': 'Contact us',
		'mls-error-screen-contact-for-help-2': 'if you need help.',
		'mls-error-screen-close': 'Close',
		'mls-error-screen-send-to-review': 'Send to review',
		'mls-error-screen-back': 'Go back',
		'mls-error-screen-confirm': 'Confirm',
		'mls-error-screen-remove-mls-id': 'Remove MLS ID',

		'mls-error-unknown': 'An unknown error occurred, please try again or contact support.',
		'mls-error-offline': 'Cannot reach server. Please check your network connection and try again in a few seconds.',

		'mls-error-company-not-found': 'Company not found. Please try again or contact support.',
		'mls-error-internal-server-error': 'Internal server error. Please try again or contact support.',
		'mls-error-invalid-add-connection-with-office-id-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-add-connection-with-agent-id-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-add-office-to-connection-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-delete-connection-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-delete-office-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-add-agent-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-delete-agent-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-edit-agent-packet': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-connection-id': 'Bad request. Please try again or contact support.',
		'mls-error-invalid-company-id':  'Bad request. Please try again or contact support.',
		'mls-error-invalid-user-session': 'Invalid user session. Please try again or contact support.',
		'mls-error-connection-not-found': 'Error, connection not found. Please try again or contact support.',
		'mls-error-office-not-found': 'Error, office not in connection. Please try again or contact support.',
		'mls-error-agent-not-found': 'Agent not found. Please try again or contact support.',
		'mls-error-api-key-required': 'Missing Real Estate API key',
		'mls-error-agent-mls-id-already-assigned': 'This ID is already taken. Contact us if this is your ID.',
		'mls-error-failed-to-list-agents': 'Server error. Please try again or contact support.',
		'mls-error-invalid-agent-id-format': 'Agent ID format invalid',
		'mls-error-rate-limit-reached': 'Maximum number of attempts reached, please contact Xara support.',
		'mls-connection-popup-error-failed-to-load-mls-board-list': 'Failed to load MLS config list. Please check your network connection and try again in a few seconds or contact Xara support.',
		'mls-error-loading-mls-data': 'MLS data failed to load. Please check your network connection and try again in a few seconds or contact Xara support.',
		'mls-field-error-data-not-loaded': 'Error loading data.',

		'mls-error-email-not-verified': 'Your email must be verified first. We sent you an email to verify your email address. Please click on the link in email and try again.',
		'mls-error-subscription-needed': 'Please upgrade to add more than five connections.',
		'mls-error-connection-limit-reached': 'Maximum number of connections reached, please contact Xara support.',

		'mls-popup-no-listings-found': 'We couldn\'t find listings',
		'mls-popup-no-listings-found-for-agent': 'We couldn\'t find listings for agent MLS ID.',
		'mls-popup-no-listings-found-for-office-id': 'We couldn\'t find listings in <strong>{0}</strong> for office ID <strong>{1}</strong>.<br><br>Please check that the correct MLS is selected and the ID is entered exactly (including any prefixes or hyphens).<br><br>If everything looks right, we can review it for you.',
		'mls-popup-no-listings-found-for-agent-id': 'We couldn\'t find listings in <strong>{0}</strong> for agent MLS ID <strong>{1}</strong>.<br><br>Please check that the correct MLS is selected and the ID is entered exactly (including any prefixes or hyphens).<br><br>If you know your office ID, click \'Go back\' and enter the office ID.<br><br>If everything looks right, we can review it for you.',

		'mls-error-invalid-mls-board-name': 'You provided invalid MLS board.<br><br>Please make sure the information you give is correct and try again.',

		'mls-popup-agent-already-exists': 'Agent already exists.',

		'mls-list-loading': 'Please wait, loading MLS data...',
		'mls-list-no-mls-connected': 'No MLS connected',
		
		'mls-list-office-name': 'Office name',
		'mls-list-office-id': 'Office ID',
		'mls-list-office-delete-office': 'Delete office',

		'mls-list-add-office': 'Add office',
		'mls-list-manage-agents': 'Manage agents',

		'mls-connection-removed': 'Connection {0} was removed',
		'mls-office-removed': 'Office {0} was removed',

		'remove-mls-confirmation-title': 'Delete {0}?',
		'remove-mls-confirmation-description': 'All agent IDs saved for this MLS across your team will be deleted.<br><br>If you\'re updating the office, add the new one before removing this.',

		'remove-mls-confirmation': 'Are you sure you want to delete <strong>{0}</strong>?',
		'remove-office-confirmation': 'Are you sure you want to delete office <strong>{0}</strong>?',

		'mls-agents-table-no-users-found': 'No users found',
		'mls-agents-table-add-user-to-team': 'Add user to team',

		're-api-error-invalid-mls-connection-config': 'Server error: Invalid MLS connection config. Please contact Xara support.',
		're-api-error-invalid-office-id': 'Server error: invalid office ID.',
		're-api-error-invalid-agent-code': 'Server error: Invalid agent code.',
		're-api-error-invalid-api-key': 'Server error: Invalid API key. Please contact Xara support.',
		're-api-error-re-api-internal-server-error': 'API internal server error. Please contact Xara support.',

		'http-error-internal-server-error': 'Internal server error. Please contact Xara support.',
		'http-error-mising-company-id': 'Error: missing company ID',
		'http-error-missing-user-id': 'Error: missing user ID',

		'onboarding-members-title': 'Invite your team members!',
		'onboarding-members-email-placeholder': 'Email Address',
		'onboarding-members-email-invalid': 'Invalid email address',
		'onboarding-members-email-duplicate': 'Email is already on the list',
		'onboarding-members-add-more': 'Add more',
		'onboarding-members-next': 'Next',
		'onboarding-members-skip': 'Skip for now',
		'onboarding-members-o-title': 'Invite team members',
		'onboarding-members-o-message': 'To ensure your team is on the same page and being productive add them now.',

		'onboarding-brandspace-image-alt': 'Create a Theme',
		'onboarding-brandspace-title': 'Create your first Theme',
		'onboarding-brandspace-text': 'Themes automatically apply your style across all the graphics and documents your team creates, to ensure a consistent look and feel.',
		'onboarding-brandspace-skip': 'Skip for now',
		'onboarding-brandspace-go-to-style-editor': 'Go to theme style editor',
		'onboarding-brandspace-o-title': 'Create a Theme',
		'onboarding-brandspace-o-message': 'To enable auto branding we recommend setting up a Theme - it takes seconds.',

		'onboarding-congratulations-title': 'Congratulations!',
		'onboarding-congratulations-subtitle': 'We are ready to go.',
		'onboarding-congratulations-complete-profile1': 'Do you want to complete your ',
		'onboarding-congratulations-complete-profile2': 'team profile',
		'onboarding-congratulations-skipped-title': 'Your team was created successfully!',
		'onboarding-congratulations-skipped-subtitle': 'Next steps to enjoy the full power of Xara Cloud for Teams:',
		'onboarding-congratulations-or': 'or',
		'onboarding-congratulations-start-creating': 'Start creating!',

		'company-create-error-min-max-chars': 'Please enter more than 3 characters.',
		'company-create-error-multiple-spaces': 'You may not have multiple consecutive spaces.',
		'company-create-error-invalid-name': 'This name is already taken, please choose another company name.',

		'showcase-headline1': 'Headline 1',
		'showcase-headline2': 'Headline 2',
		'showcase-headline3': 'Headline 3',
		'showcase-caption': 'Caption',
		'showcase-explanation': 'Explanation',
		'showcase-body1': 'Body 1',
		'showcase-body2': 'Body 2',
		'showcase-launch-editor': 'Launch Editor',
		'showcase-email-placeholder': 'Email Address',
		'showcase-email-value': 'example@mail.com',
		'showcase-disabled-placeholder': 'Disabled',
		'showcase-disabled-value': 'Disabled',
		'showcase-select-placeholder': 'Placeholder',
		'showcase-select-option-10': 'Ten',
		'showcase-select-option-20': 'Twenty',
		'showcase-select-option-30': 'Thirty',
		'showcase-multiline-placeholder': 'Description',
		'showcase-confirmation-popup': 'Confirmation popup',
		'showcase-confirmation-popup-title': 'Confirmation',
		'showcase-confirmation-popup-message': 'Confirmation message. It may contain HTML, use { __html: [message] } notation.<br />You can show modal by passing the following props:<br /><br />title (optional)<br />message<br />buttons (array of React Components)<br />hideModalOnButtonClick',
		'showcase-confirmation-popup-confirm': 'Confirm',
		'showcase-error-popup': 'Error popup',
		'showcase-info-link': 'Some info',
		'showcase-info-title': 'Account types:',
		'showcase-info-text1': '<strong>Admin</strong>: Full admin rights (add member and manage themes).',
		'showcase-info-text2': '<strong>Member</strong>: Full access and management rights to all Themes.',
		'showcase-info-text3': '<strong>Guest</strong>: Can be invited to edit a team document.',
		'showcase-tab1': 'Tab 1',
		'showcase-tab2': 'Tab 2',
		'showcase-tab3': 'Tab 3',
		'showcase-table-head-email': 'Email',
		'showcase-table-head-account-type': 'Account type',
		'showcase-table-body-email': 'example@mail.com',
		'showcase-table-select-option1': 'Account type',
		'showcase-table-select-option2': 'Admin',
		'showcase-table-select-option3': 'Guest',

		'company-selection-modal-select-team': 'You are admin of multiple teams. Please select the team you would like to access.',
		'company-selection-modal-selector': 'Please select',

		'guest-modal-message': 'You are a Guest of the team but you are not an Administrator so cannot manage the team.',
		'guest-modal-message-can-select-different-team': 'You can select a different team or create a new team.',
		'guest-modal-create-new-team': 'Create new Team',
		'guest-modal-selector': 'Please select',

		'upgrade-company-modal-admin-message': 'Please select the team you want to upgrade.',
		'upgrade-company-modal-upgrade': 'Upgrade',
		'upgrade-company-modal-member-message': 'You are a Member of the team but you are not an Administrator so cannot manage the team\'s subscription. You can inform an Admin, select a different team or create a new team to start a subscription.',
		'upgrade-company-modal-create-new-team': 'Create new Team',
		'upgrade-company-modal-selector': 'Please select',

		'processing-order': 'Processing order',

		'wrong-account-title': 'Welcome to Xara!',
		'wrong-account-signed-in-title': 'You are currently signed in as:',
		'wrong-account-use-existing-account': 'Continue with this account',
		'wrong-account-change-account': 'Sign out and sign in with a different account',

		'fallback-screen-message': 'Oops! Looks like something went wrong. Let\'s try it again!',
		'fallback-screen-message-browser-extension': 'A browser extension has crashed and is impacting your use of Xara Workspaces. Please refresh to continue. If this occurs again please disable one or more of your extensions.',
		'fallback-screen-reload': 'Reload the application',

		'no-permissions-admin-only': 'This section is only available to Team Admins',

		'not-found-title': 'Page not found',
		'not-found-message1': 'We\'re sorry you didn\'t find what you were looking for.',
		'not-found-message2': 'Please use the navigation menu on the left to choose another page.',

		'page-not-available-image-alt': 'Sorry, this page is not available.',
		'page-not-available-message': 'Sorry, this page is not available.',
		'page-not-available-refresh': 'Refresh',

		'error-modal-title': 'Xara Cloud just had a hiccup',
		'error-modal-account-confirmation-message': 'We sent you a confirmation e-mail to {0}. Please check your inbox. If you\'re still not receiving the email, please check your spam folder to be sure that our emails are not being detected as spam.',

		'error-messages-button-reload': 'Reload the application',
		'error-message-unhandled': 'Oops! Looks like something went wrong. Let\'s try it again! - {0}',
		'error-message-offline': 'Cannot reach server. Please check your network connection and try again in a few seconds.',
		'error-cb-api-rate-limit-reached': 'Sorry, the server is busy, please try again in 5 minutes.',
		'error-number-of-users-on-non-paying-account-exceeded': 'Please upgrade to invite more than 2 collaborators.',

		'error-message-xhr-failed': 'Network request failed, please try again in a few seconds. Contact us immediately if you are unable to continue.',
		'error-message-invalid-company-id-or-company-name': 'This team name is already taken. Please enter a different name.',
		'error-message-insufficient-rights': 'You do not have permission to make changes. Please contact your administrator.',
		'error-message-company-not-found': 'The requested company was not found.',
		'error-message-user-not-validated': 'You must confirm your e-mail first.',
		'error-user-not-validated-resend-button': 'Resend e-mail',
		'error-message-delete-myself': 'You cannot delete yourself!',
		'error-message-invalid-phone-number': 'The phone number provided is not valid. Please enter a different number.',
		'error-message-invalid-website-url': 'The website provided is not valid. Please enter a valid website format.',
		'error-message-.invalid-company-country': 'The country provided is not valid. Please start typing and select an entry from the list.',
		'error-message-invalid-company-industry': 'The team industry provided is not valid. Please start typing and select an entry from the list.',
		'error-message-invalid-company-size': 'The team size provided is not valid. Please select an entry from the list.',
		'error-message-failed-to-create-company-subscription': 'The selected plan is not available at the moment. Please select a different plan.',
		'error-message-discontinued-plan': 'The selected plan has been discontinued. Please select a different plan.',
		'error-message-no-active-subscription': 'No access without a valid team subscription.',
		'error-message-invalid-cloud-drive-added': 'Oops! Looks like your cloud storage is empty. Please, go to your cloud storage and create a folder.',
		'error-message-payment-processing-failed': 'Transaction declined, please check the card details entered or contact your card issuer to check that the card is working correctly.',
		'error-message-payment-method-verification-failed': 'Transaction declined, please check the card details entered.',
		'error-message-payment-method-not-present': 'There is no payment method associated with your account or your credit card has expired.',
		'error-message-payment-gateway-currency-incompatible': 'The selected currency is not supported.',
		'error-message-payment-provider-internal-error': 'Payment provider internal error, please contact Xara support.',
		'error-message-payment-provider-internal-coupon-error': 'Payment provider internal error. Most likely coupon is not valid. Please contact Xara support.',
		'error-message-wrong-font-type-uploaded': 'This file format is not supported. Xara Cloud can add the following file types: .ttf .otf.',
		'error-message-checksum-conflict-invalid-font-file': 'Sorry, we could not upload this file. The file is corrupted, please upload a different file.',
		'error-message-workspace-name-already-exists': 'This name is already taken, please chose another BrandSpace name.',
		'error-message-cloud-storage-item-not-folder': 'You cannot add files. Please select a folder.',
		'error-message-cloud-storage-folder-not-writable': 'You do not have write permissions for this folder. Please select a different folder.',
		'error-message-company-name-already-exists': 'This name is already taken, please choose another team name.',
		'error-message-invalid-company-name': 'You may only use characters from A to Z, and 0 to 9 (no spaces and special characters allowed).',
		'error-message-invalid-email': 'Invalid email address.',
		'error-message-invalid-workspace-name': 'Please use only letters and digits.',
		'error-message-subscription-plan-currency-mismatch': 'The selected currency does not match your previous subscription. Please change your currency selection.',
		'error-message-company-already-exists': 'This name is already taken, please choose another team name.',
		'error-message-user-already-exists-in-company': 'This user already exists.',
		'error-message-domain-already-exists-in-company': 'This domain was already added.',
		'error-message-folder-already-exists-in-company': 'This folder was already added.',
		'error-message-smart-field-already-exists-in-company': 'This SmartField already exists.',
		'error-message-workspace-already-exists-in-company': 'This name is already taken, please choose another Theme name.',
		'error-message-user-already-exists-in-workspace': 'This user already exists.',
		'error-message-domain-already-exists-in-workspace': 'This domain was already added.',
		'error-message-waiting-for-api': 'Sorry for the inconvenience, we are currently maintaining Xara Cloud. We will be back and running shortly.',
		'error-message-cb-not-loaded': 'Could not load subscription billing library, please try again in a few seconds or see our <a href="{0}" target="_blank">support article</a>. Contact us immediately if you are unable to continue.',
		'error-message-failed-to-get-payment-coupon': 'Failed to get payment coupon. Please try again or contact support.',
		'error-message-invalid-coupon-set-id': 'Invalid coupon set id. Please try again or contact support.',
		'error-message-invalid-coupon-id': 'Invalid coupon id. Please try again or contact support.',
		'error-message-failed-to-create-order-in-payment-gateway': 'Error creating order in payment gateway. Please try again or contact support.',
		'error-message-duplicate-coupon-id': 'Duplicate coupon id. Please try again or contact support.',
		'error-message-invalid-number-of-users-during-checkout': 'The number of the users cannot be less than the number of users in the company'
	};

	if (typeof define === 'function' && define.amd) {
		define(function () {
			return exports;
		});
	} else {
		this[module] = exports;
	}

}).call(this);



// WEBPACK FOOTER //
// ./src/i18n/localisedStrings.en.js